import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import { CreateAgentDialog } from '@/components/shared/components/CreateAgentDialog/CreateAgentDialog';
import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { ChannelDetailAction } from '@/components/widgets/ChannelDetailActions/types/ChannelDetailAction';
import MerchantStructureEntity from '@/entities/MerchantStructureEntity';
import { useGetMerchantStructureById } from '@/hooks/requests/merchant/useGetMerchantStructureById';

export const ChannelDetailActions: React.FC = () => {
  const { merchantId, channelId } = useParams();

  if (!merchantId) return null;

  const { merchantStructure } = useGetMerchantStructureById(merchantId);

  const currentChannel = merchantStructure
    ? MerchantStructureEntity.create({ merchantStructure, channelId }).getChannel()
    : undefined;

  const [currentAction, setCurrentAction] = useState<ChannelDetailAction | undefined>();

  const { opened, setOpened, toggleDialog } = useDialog();

  const toggleActionDialog = (actionType: ChannelDetailAction) => {
    setCurrentAction(actionType);
    toggleDialog();
  };

  const actions: ActionsOption[] = [
    {
      display: <Text tId={'CREATE_AGENT'} />,
      onClick: () => toggleActionDialog(ChannelDetailAction.CREATE_AGENT),
      iconName: 'add',
    },
  ];
  return (
    <>
      <MoreActionsMenu actionsOptionsArray={actions}>
        <Button>
          <Font variant={'subtitle2'} color={'textSecondary'}>
            <i
              className={'material-icons-outlined mr-2'}
              style={{ verticalAlign: '-5px', marginLeft: '-4px', fontSize: '1.5em' }}
            >
              menu
            </i>
            <Text tId={'ACTIONS'} />
          </Font>
        </Button>
      </MoreActionsMenu>
      {currentAction === ChannelDetailAction.CREATE_AGENT && merchantId && currentChannel && (
        <CreateAgentDialog
          merchantId={merchantId}
          currentChannel={currentChannel}
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
        />
      )}
    </>
  );
};
